import script from "./FilterWine.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterWine.vue?vue&type=script&setup=true&lang=js"

import "./FilterWine.vue?vue&type=style&index=0&id=2888598a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2888598a"]])

export default __exports__